import api from './api';
import { API_URL } from '../config';
import { UserRole, UserStatus } from '../types/user';

export interface UserFormData {
  id?: string;
  lastName: string;
  firstName: string;
  middleName?: string;
  email: string;
  role: UserRole;
  roles?: UserRole[];
  status: UserStatus;
  password?: string;
}

export interface User extends UserFormData {
  id: string;
  createdAt: string;
  updatedAt: string;
}

const userService = {
  async getUsers(): Promise<User[]> {
    try {
      console.log('Запрос пользователей:', `${API_URL}/users`);
      const response = await api.get<User[]>('/users');
      console.log('Ответ сервера:', response.data);
      return response.data;
    } catch (error) {
      console.error('Ошибка при получении пользователей:', error);
      throw error;
    }
  },

  async getUserById(id: string): Promise<User> {
    const response = await api.get<User>(`/users/${id}`);
    return response.data;
  },

  async createUser(userData: UserFormData): Promise<User> {
    const response = await api.post<User>('/users', userData);
    return response.data;
  },

  async updateUser(id: string, userData: Partial<UserFormData>): Promise<User> {
    const response = await api.put<User>(`/users/${id}`, userData);
    return response.data;
  },

  async deleteUser(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  },

  async getUsersByRole(role: UserRole): Promise<User[]> {
    console.log('Запрос пользователей по роли:', role);
    const response = await api.get<User[]>(`/users/by-role?role=${role}`);
    console.log('Получены пользователи по роли:', response.data);
    return response.data;
  }
};

export default userService; 